export default __webpack_public_path__ + "static/media/deep-state-hoisting.14f20950.gif";